import GameState from './GameState'
import { RESOURCE } from './constants'
import Resource from './Resource'
import ResourceList from './ResourceList'

class Card {
    static fromCsv( csv ) {
        return new Card({ 
            id: csv['id'],
            title: csv['Card name'],
            resources: new ResourceList([
                new Resource({ type: RESOURCE.HEALTH, amount: (csv['health gain'] || 0 ) - (csv['Health cost'] || 0 )}),
                new Resource({ type: RESOURCE.SANITY, amount: (csv['sanity gain'] || 0 ) - (csv['sanity cost'] || 0 )}),
                new Resource({ type: RESOURCE.SUPPLIES, amount: (csv['supply gain'] || 0 ) - (csv['Supply cost'] || 0 )}),
                new Resource({ type: RESOURCE.FAME, amount: (csv['fame gain'] || 0 ) - (csv['Fame cost'] || 0 )})
            ]),
            alt: csv['Card name']
        })
    }

    constructor({ id, resources, title, img, alt, description }) {
        this.id = id
        this.resources = resources
        this.title = title
        this.img = img
        this.alt = alt
        this.description = description
    }

    get cost() {
        return this.resources.cost
    }

    get earnings() {
        return this.resources.earnings
    }

    play( gameState ) {
        const [ drawnCards, newDeck ] = gameState.deck.draw(2)
        const shuffledDeck = newDeck.shuffle(gameState.hand.find(card => card.id !== this.id ))
        return new GameState({
            deck: shuffledDeck, 
            hand: drawnCards, 
            resources: gameState.resources.compute(this.resources)
        })
    }

    shuffle( gameState ) {
        return new GameState({
            ...gameState,
            deck: gameState.deck.shuffle( this )
        })
    }
}

export default Card